import { render, staticRenderFns } from "./addGoodsForm.vue?vue&type=template&id=f94732e0&scoped=true&"
import script from "./addGoodsForm.vue?vue&type=script&lang=js&"
export * from "./addGoodsForm.vue?vue&type=script&lang=js&"
import style0 from "./addGoodsForm.vue?vue&type=style&index=0&id=f94732e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94732e0",
  null
  
)

export default component.exports